<template>
    <!--Tab -->
    <div >
        <div class="tab-relacionado animated slideInUp">
            <ul class="nav nav-tabs "  >
            <li :class="(ofertasList.length  >0) ? 'active' : ''" style="border-radius: 0px;"><a data-toggle="tab" v-if="ofertasList.length > 0  &&  (typeof ofertasList !== 'undefined' ) " href="#ofertas">OFERTA</a></li> 
            <li :class="(ofertasList.length ==0 && contactNews.length  >0) ? 'active' : ''" style="border-radius: 0px;"><a data-toggle="tab" v-if="contactNews.length > 0  &&  (typeof contactNews !== 'undefined' ) " href="#noticias">NOTICIAS</a></li>
            <li :class="(contactNews.length ==0 && contactNewsE.length >0) ? 'active' : ''"><a data-toggle="tab" href="#english"  v-if="contactNewsE.length > 0  &&  (typeof contactNewsE !== 'undefined' ) "  >ENGLISH NEWS</a></li>
            <li :class="(contactNews.length ==0 && contactVideosNew.length >0) ? 'active' : ''"><a data-toggle="tab" href="#videos"  v-if="contactVideosNew.length > 0   &&  (typeof contactVideosNew !== 'undefined' ) " >VIDEOS</a></li>

            </ul>
            <div class="tab-content scroll-not">
                 <!-- Tab Noticias -->
            <div id="ofertas" class="tab-pane fade"  :class="(ofertasList.length  >0) ? 'active in' : ''"  v-if="ofertasList  && ofertasList.length > 0  &&  (typeof ofertasList !== 'undefined' ) " >
               <div class="row">
              <div class="oferta" v-for="(tmpContNot,key,index) in ofertasList" v-if="ofertasList  && ofertasList.length > 0  &&  (typeof ofertasList !== 'undefined' )"  >
                  <div class="col-sm-6 divOfer" align="center">
                      <div class="img-ficha">
                        <a target="_blank" :href="'http://especiales.produ.com/trailersingle/'+tmpContNot.IdEspecialTrailer+'/'+tmpContNot.IdPrograma" >
                            <img :src="'https://images.produ.com/programas/'+tmpContNot.UbicacionFicha"  class="img-responsive imgOfer" >
                        </a>
                      </div>
                      <div class="titulo-ficha">
                          <div class="row">
                              <div class="col-sm-8">
                                    <h3><a :href="'http://especiales.produ.com/trailersingle/'+tmpContNot.IdEspecialTrailer+'/'+tmpContNot.IdPrograma" v-html="tmpContNot.Titulo" target="_blank" ></a></h3>
                                    <p v-html="tmpContNot.QtyEpisodios"></p>
                              </div>  
                              <div class="col-sm-4 ficha-icon">
                                      <img src="../../assets/images/icon-ficha.png">
                                      <span><a :href="'http://especiales.produ.com/trailersingle/'+tmpContNot.IdEspecialTrailer+'/'+tmpContNot.IdPrograma" target="_blank">FICHA</a></span>
                              </div>  
                          </div>
                      </div>
                      </div>
                  </div>
                </div>
                 <div align="center">
                    <ul class="pagination pagOfer">
                    <li :class="(currentPageNotOfer-1 == 0 ) ? 'disabled' : '' ">
                    <a @click.prevent="paginationOferta('prev',total_pagesNotOfer,currentPageNotOfer)"   >&laquo;</a></li>

                    <li v-for="value in total_pagesNotOfer"  :class="(currentPageNotOfer == value ) ? 'active' : '' "   v-if="resultSearchCounterNot>0 && ofertasList && (value<10+currentPageNotOfer  && value>=currentPageNotOfer )"    ><a    @click.prevent="currentPageNotOfer=value;pageNumNotOferta(currentPageNotOfer)" v-html="value"  ></a></li>
                    <li :class="(total_pagesNotOfer == currentPageNotOfer ) ? 'disabled' : '' "><a  
                    @click.prevent="paginationOferta('next',total_pagesNotOfer,currentPageNotOfer)"  v-if="resultSearchCounterNotOfer>0 && ofertasList">&raquo;</a></li>
                    </ul>
                  </div>
              </div>
  
            <!-- Tab Noticias -->
            <div id="noticias" class="tab-pane fade"  :class="(ofertasList.length ==0 && contactNews.length >0) ? 'active in' : ''"  v-if="contactNews  && contactNews.length > 0  &&  (typeof contactNews !== 'undefined' ) " >
              <div class="noticia" v-for="(tmpContNot,key,index) in contactNews" v-if="contactNews  && contactNews.length > 0  &&  (typeof contactNews !== 'undefined' )"  >
                <div class="row">
                  <div class="col-sm-2" align="center">
                    <div class="imagen-tab-ne" >
                      <a target="_blank" :href="'http://www1.produ.com/noticias/'+tmpContNot.permalink" >
                          <div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/noticias/'+( (tmpContNot.Subfolder) ? tmpContNot.Subfolder+'/' : '' )+ tmpContNot.Ubicacion+')' }" ></div>
                      </a>
                    </div>
                  </div>
                  <div class="col-sm-10">
                    <div class="info-tabs">
                      <a target="_blank" :href="'http://www1.produ.com/noticias/'+tmpContNot.permalink" ><h3 v-html="tmpContNot.Headline"></h3></a>
                      <p>{{  setDateFormat1ByLanguage('es', tmpContNot.Date )  }}</p>
                    </div>
                  </div>

                </div>
              </div>

              <div align="center">
                 <ul class="pagination">
                <li :class="(currentPageNot-1 == 0 ) ? 'disabled' : '' ">
                <a @click.prevent="paginationNoticias('prev',total_pagesNot,currentPageNot)"   >&laquo;</a></li>

                <li v-for="value in total_pagesNot-1"  :class="(currentPageNot == value ) ? 'active' : '' "   v-if="resultSearchCounterNot>0 && contactNews && (value<10+currentPageNot  && value>=currentPageNot )"    ><a    @click.prevent="currentPageNot=value;pageNumNot(currentPageNot)" v-html="value"  ></a></li>
                <li :class="(total_pagesNot-1 == currentPageNot ) ? 'disabled' : '' "><a  
                @click.prevent="paginationNoticias('next',total_pagesNot,currentPageNot)"  v-if="resultSearchCounterNot>0 && contactNews">&raquo;</a></li>
                </ul>
              </div>
            </div>
            <!-- Tab English -->
            <div id="english" class="tab-pane fade" :class="(contactNews.length ==0 && contactNewsE.length >0) ? 'active in' : '' "  v-if="contactNewsE.length > 0   &&  (typeof contactNewsE !== 'undefined' )" >
              <div class="noticia" v-for="(tmpContNot,key,index) in contactNewsE" v-if="contactNewsE  && contactNewsE.length > 0  &&  (typeof contactNewsE !== 'undefined' )"  >
                <div class="row">
                  <div class="col-sm-2" align="center">
                    <div class="imagen-tab-ne" >
                      <a target="_blank" :href="'http://www1.produ.com/hispanictv/noticias/'+tmpContNot.ID" ><div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/noticias/'+( (tmpContNot.Subfolder) ? tmpContNot.Subfolder+'/' : '' )+ tmpContNot.Ubicacion+')' }" ></div></a>
                    </div>
                  </div>
                  <div class="col-sm-10">
                    <div class="info-tabs">
                      <a target="_blank" :href="'http://www1.produ.com/hispanictv/noticias/'+tmpContNot.ID" ><h3 v-html="tmpContNot.Headline"></h3></a>
                      <p>{{  setDateFormatEnglish(tmpContNot.Date )  }}</p>
                    </div>
                  </div>

                  </div>
              </div>


              <div align="center">
                 <ul class="pagination">
                  <li>
                  <a :readonly="currentPageNotE <= 0"  @click.prevent="currentPageNotE=currentPageNotE-1;pageNumNotE(currentPageNotE)"    >&laquo;</a></li>

                  <li v-for="value in total_pagesNotE-1"  :class="(currentPageNotE == value ) ? 'active' : '' "   v-if="resultSearchCounterNotE>0 && contactNewsE && (value<10+currentPageNotE  && value>=currentPageNotE )"    ><a    @click.prevent="currentPageNotE=value;pageNumNotE(currentPageNotE)" v-html="value"  ></a></li>
                  <li><a disabled="currentPageNotE <= total_pagesNotE - 1" @click.prevent="currentPageNotE=currentPageNotE+1;pageNumNotE(currentPageNotE)"  v-if="resultSearchCounterNotE>0 && contactNewsE"   >&raquo;</a></li>
                </ul>
              </div>
            </div>
            <!-- Tab Video -->
            <div id="videos" class="tab-pane fade" :class="(contactNews.length ==0 && contactVideosNew.length >0) ? 'active in' : '' "   v-if="contactVideosNew && contactVideosNew.length > 0  &&  (typeof contactVideosNew !== 'undefined' )"  >
              <div class="noticia" v-for="(tmpConVid,key,index) in contactVideosNew" v-if="contactVideosNew  && contactVideosNew.length > 0  &&  (typeof contactVideosNew !== 'undefined' )"  >
                <div class="row">
                  <div class="col-sm-2" align="center">
                    <div class="imagen-tab-ne" >
                      <a target="_blank" :href="'http://www1.produ.com/videos/'+tmpConVid.IdVideo" ><div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/fotos/'+( (tmpConVid.Subfolder) ? tmpConVid.Subfolder+'/' : '' )+ tmpConVid.Ubicacion+')' }" ></div></a>
                    </div>
                  </div>
                  <div class="col-sm-10">
                    <div class="info-tabs">
                      <a target="_blank" :href="'http://www1.produ.com/videos/'+tmpConVid.IdVideo" ><h3 v-html="tmpConVid.Titulo"></h3></a>
                      <p>{{  setDateFormat1ByLanguage('es', tmpConVid.Fecha )  }}</p>
                    </div>
                  </div>

                </div>
              </div>


              <!--<div align="center">
                 <ul class="pagination">
                  <li>
                  <a :readonly="currentPageNotE <= 0"  @click.prevent="currentPageNotE=currentPageNotE-1;pageNumNotE(currentPageNotE)"    >&laquo;</a></li>

                  <li v-for="value in total_pagesNotE-1"  :class="(currentPageNotE == value ) ? 'active' : '' "   v-if="resultSearchCounterNotE>0 && contactNewsE && (value<10+currentPageNotE  && value>=currentPageNotE )"    ><a    @click.prevent="currentPageNotE=value;pageNumNotE(currentPageNotE)" v-html="value"  ></a></li>
                  <li><a disabled="currentPageNotE <= total_pagesNotE - 1" @click.prevent="currentPageNotE=currentPageNotE+1;pageNumNotE(currentPageNotE)"  v-if="resultSearchCounterNotE>0 && contactNewsE"   >&raquo;</a></li>
                </ul>
              </div>-->
            </div>
            </div>
        </div>
    </div>
</template>


<script>
var resfulApi="https://backend.produ.com/admin/index.php/welcome/"

import axios from 'axios'

export default {
  name: 'Content',
  data () {
    return {
        contactNews:[],
        ofertasList:[],
        especialID : '',

        resultSearchCounterNot: 0,

        currentPageNot: 1,
        query_rowsNot:10,
        total_pagesNot:0,
        pageSizeNot: 10,
        pageNot: 1,
        total_pagesNotOfer:0,

        contactNewsE: [],

        resultSearchCounterNotE: 0,
        resultSearchCounterNotOfer: 0,

        currentPageNotE: 1,
        currentPageNotOfer:1,
        query_rowsNotE:10,
        total_pagesNotE:0,
        pageSizeNotE: 10,
        pageNotE: 1,

        contactVideosNew: [],

        resultSearchCounterVideos: 0,

        currentPageVideos: 1,
        query_rowsVideos:10,
        total_pagesVideos:0,
        pageSizeVideos: 10,
        pageVideos: 1,



        companyID:0,
    }
  },
  created () {

  },
  methods: {
      moment: function () {
        return moment()
      },
      pageNumNot: async function(currPageIn){


          await axios.post(resfulApi+'getCompanyNoticiasWWFWS', {
              token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
              companyIN: this.contactID,
              page: currPageIn
            }).then((response)  =>  {

              this.resultSearch =[]
              this.resultSearchCounter=0
              this.total_pages=0
              this.contactNews =response.data.result


              if(response.data.totalRecordsContNews>0 &&  response.data.result) {
                  window.scrollTo(0, 0)

                  this.resultSearchCounterNot=response.data.totalRecordsContNews

                  this.total_pagesNot =  Math.ceil(  this.resultSearchCounterNot/this.query_rowsNot ) ;

                  if( this.resultSearchCounterNot % this.query_rowsNot %this.query_rowsNot > 0 ){
                     this.total_pagesNot = this.total_pagesNot+1
                  }
              }



              this.$nextTick(function(){

              })
          })

      },
      getCompanyNoticiasWWFWS: async function(contacID,pageIN){
          this.contactID=contacID

          await axios.post(resfulApi+'getCompanyNoticiasWWFWS', {
              token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
              companyIN: this.contactID,
              page: pageIN
            }).then((response)  =>  {

              this.resultSearch =[]
              this.resultSearchCounter=0
              this.total_pages=0
              this.contactNews =response.data.result

              if(response.data.totalRecordsContNews>0 &&  response.data.result) {

                  this.resultSearchCounterNot=response.data.totalRecordsContNews

                  this.total_pagesNot =  Math.ceil(  this.resultSearchCounterNot/this.query_rowsNot ) ;

                  if( this.resultSearchCounterNot % this.query_rowsNot %this.query_rowsNot > 0 ){
                     this.total_pagesNot = this.total_pagesNot+1
                  }
              }

              this.$nextTick(function(){

              })
          })

      },
      pageNumNotE: async function(currPageIn){

          await axios.post(resfulApi+'getCompanyDataNotEWWFWS', {
              token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
              companyIN: this.contactID,
              page: currPageIn
            }).then((response)  =>  {

              this.resultSearchCounterNotE=0
              this.total_pagesNotE=0
              this.contactNewsE =response.data.result

              if(response.data.totalRecordsContNews>0 &&  response.data.result) {
                  window.scrollTo(0, 0)
                  this.resultSearchCounterNotE=response.data.totalRecordsContNews

                  this.total_pagesNotE =  Math.ceil(  this.resultSearchCounterNotE/this.query_rowsNotE ) ;

                  if( this.resultSearchCounterNotE % this.query_rowsNotE %this.query_rowsNotE > 0 ){
                     this.total_pagesNotE = this.total_pagesNotE+1
                  }
              }

              this.$nextTick(function(){

              })
          })

      },
      getCompanyDataNotEWWFWS: async function(contacID,pageIN){
          this.contactID=contacID

          await axios.post(resfulApi+'getCompanyDataNotEWWFWS', {
              token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
              companyIN: this.contactID,
              page: pageIN
            }).then((response)  =>  {

                this.resultSearchCounterNotE=0
                this.total_pagesNotE=0
                this.contactNewsE =response.data.result


                if(response.data.totalRecordsContNews>0 &&  response.data.result) {

                    this.resultSearchCounterNotE=response.data.totalRecordsContNews

                    this.total_pagesNotE =  Math.ceil(  this.resultSearchCounterNotE/this.query_rowsNotE ) ;

                    if( this.resultSearchCounterNotE % this.query_rowsNotE %this.query_rowsNotE > 0 ){
                       this.total_pagesNotE = this.total_pagesNotE+1
                    }
                }

                this.$nextTick(function(){

                })
          })

      },
      pageNumVid: async function(currPageIn){

          await axios.post(resfulApi+'get_VideosCompaniesWWFWS', {
              token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
              companyIN: this.contactID,
              pageIN: currPageIn
            }).then((response)  =>  {

              this.resultSearchCounterVideos=0
              this.total_pagesVideos=0
              this.contactVideosNew =response.data.result

              if(response.data.totalRecordsContVids>0 &&  response.data.result) {
                  window.scrollTo(0, 0)

                  this.contactVideosNew =response.data.result
                  this.resultSearchCounterVideos=response.data.totalRecordsContVids

                  this.total_pagesVideos =  Math.ceil(  this.resultSearchCounterVideos/this.query_rowsNot ) ;

                  if( this.resultSearchCounterVideos % this.query_rowsVideos %this.query_rowsVideos > 0 ){
                     this.total_pagesVideos = this.total_pagesVideos+1
                  }

              }

              this.$nextTick(function(){

              })
          })

      },
      paginationNoticias: async function(direction,total_pagesNot,currentPageNot) {
          if(direction=='prev'){
             (currentPageNot- 1==0) ? '' : this.pageNumNot(--this.currentPageNot)
          }else {
             (currentPageNot == total_pagesNot - 1) ? '' : this.pageNumNot(++this.currentPageNot)
          }
      },
      paginationOferta: async function(direction,total_pagesNotOfer,currentPageNotOfer) {
          if(direction=='prev'){
             (currentPageNotOfer- 1==0) ? '' : this.pageNumNotOferta(--this.currentPageNotOfer)
          }else {
             (currentPageNotOfer == total_pagesNotOfer) ? '' : this.pageNumNotOferta(++this.currentPageNotOfer)
          }
      },
      get_VideosCompaniesWWFWS: async function(companyID,pageIN){
          this.companyID=companyID

          await axios.post(resfulApi+'get_VideosCompaniesWWFWS', {
              token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
              companyIN: this.companyID,
              page: pageIN
            }).then((response)  =>  {

                this.resultSearchCounterVideos=0
                this.total_pagesVideos=0
                this.contactVideosNew =response.data.result

                if(response.data.totalRecordsContVids>0 &&  response.data.result) {
                    this.contactVideosNew =response.data.result
                    this.resultSearchCounterVideos=response.data.totalRecordsContVids

                    this.total_pagesVideos =  Math.ceil(  this.resultSearchCounterVideos/this.query_rowsNot ) ;

                    if( this.resultSearchCounterVideos % this.query_rowsVideos %this.query_rowsVideos > 0 ){
                       this.total_pagesVideos = this.total_pagesVideos+1
                    }

                }

              this.$nextTick(function(){

              })
          })

      },
      getOfertaByCompany: async function(contacID,pageIN){
          this.contactID=contacID

          await axios.post(resfulApi+'getOfertaByCompany', {
              token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
              companyIN: this.contactID,
              page: pageIN
            }).then((response)  =>  {

              this.resultSearch =[]
              this.resultSearchCounter=0
              this.total_pages=0
              this.ofertasList =response.data.result
              this.especialID  =response.data.IdEspecial;
          
              if(response.data.totalRecordsOfertas>0 &&  response.data.result) {

                  this.resultSearchCounterNotOfer=response.data.totalRecordsOfertas
                
                  this.total_pagesNotOfer =  Math.ceil(  this.resultSearchCounterNotOfer/this.query_rowsNot ) ;
                 
                  if( this.resultSearchCounterNotOfer % this.query_rowsNot %this.query_rowsNot > this.query_rowsNot  ){
                     this.total_pagesNotOfer = this.total_pagesNotOfer+1
                   
                  }
              }

              this.$nextTick(function(){

              })
          })

      },
      pageNumNotOferta: async function(currPageIn){


          await axios.post(resfulApi+'getOfertaByCompany', {
              token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
              companyIN: this.contactID,
              page: currPageIn
            }).then((response)  =>  {

              this.resultSearch =[]
              this.resultSearchCounter=0
              this.total_pages=0
              this.ofertasList =response.data.result
              this.especialID  = response.data.IdEspecial;


              if(response.data.totalRecordsOfertas>0 &&  response.data.result) {
                  window.scrollTo(0, 0)

                  this.resultSearchCounterNotOfer=response.data.totalRecordsOfertas

                  this.total_pagesNotOfer =  Math.ceil(  this.resultSearchCounterNotOfer/this.query_rowsNot ) ;
                  
              }



              this.$nextTick(function(){

              })
          })

      },

  },
  beforeMount() {

  },
  mounted: function () {
      this.contactID= this.$route.params.empresa

      this.getCompanyNoticiasWWFWS(this.contactID,1)
      this.getCompanyDataNotEWWFWS(this.contactID,1)
      this.get_VideosCompaniesWWFWS(this.contactID,1)
      this.getOfertaByCompany(this.contactID,1)
  },
  watch: {
      '$route.params.empresa'(newId, oldId) {
          this.contactID=newId
          this.getCompanyNoticiasWWFWS(this.contactID,1)
          this.getCompanyDataNotEWWFWS(this.contactID,1)
          this.get_VideosCompaniesWWFWS(this.contactID,1)
          this.getOfertaByCompany(this.contactID,1)
      }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .media-body a {
    color: #4e4e4e;

  }
</style>



// WEBPACK FOOTER //
// src/components/company/Content.vue